type MessageType = {
  message: string
  note?: string
  shortName?: string
}

type NotesType = {
  [key: string]: string
}

type ModuleMessageType = {
  [key: string]: {
    notes?: NotesType
    [key: string]: MessageType[] | NotesType | undefined
  }
}

// IMPORTANT NOTE: Keep in sync with
// apps\portal\src\app\components\AlertsTable\InfractionTableHelpers.ts

// ToDo: https://dev.azure.com/qualisflow/Platform/_workitems/edit/18396 - Simplify and Update Descriptions for Submission Issues to remove front-end control of these values.

export const MessagePresets: ModuleMessageType = {
  Delivery: {
    deliveryId: [
      {
        message:
          'Unable to extract some information due to a blurred photo. Please upload a better photo.',
        shortName: 'Blurry'
      },
      {
        message:
          'Unable to extract some information from the ticket. Please ensure the entire ticket is captured within the photo.',
        shortName: 'Cut Off'
      },
      {
        message:
          'This looks like a photo has been taken of another tablet or mobile device. If an eTicket is available, please send this to your Qflow email address or speak to your Customer Success Manager about eTicket opportunities.',
        shortName: 'Screen'
      },
      {
        message:
          'This looks like a photo has been taken of a truck. If a Delivery Note is available please upload this instead.',
        shortName: 'WW Truck'
      }
    ]
  },
  Waste: {
    consignmentId: [
      {
        message:
          'Unable to extract some information due to a blurred photo. Please upload a better photo.',
        shortName: 'Blurry'
      },
      {
        message:
          'Unable to extract some information from the ticket. Please ensure the entire ticket is captured within the photo.',
        shortName: 'Cut Off'
      },
      {
        message:
          'This looks like a photo has been taken of another tablet or mobile device. If an eTicket is available, please send this to your Qflow email address or speak to your Customer Success Manager about eTicket opportunities.',
        shortName: 'Screen'
      },
      {
        message:
          'This looks like a photo has been taken of a truck. If a Waste Transfer Note is available please upload this instead.',
        shortName: 'WW Truck'
      }
    ]
  }
}
